import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  InputAdornment,
  TextField,
} from "@mui/material";
import Joi from "joi";
import React from "react";
import { Link } from "react-router-dom";
import authService from "../../../../services/authService";
import { getNavItems } from "../../../../services/navService";
import Form from "../../../common/form";
import { Visibility, VisibilityOff } from "@mui/icons-material";

class SignInForm extends Form {
  state = {
    data: { username: "", password: "" },
    groups: [],
    errors: {},
  };

  schema = {
    username: Joi.string().required().label("Username"),
    password: Joi.string().required().label("Password"),
    // rememberme: Joi.boolean(),
  };

  // handleClickShowPassword(showPassword) {
  //   this.setState({ showPassword })
  // }

  componentDidMount() {
    // this.getGroups()
  }


  doSubmit = async () => {
    try {
      const { data } = this.state;
      await authService.login(data.username, data.password);
      authService.setCurrentRole();
      const defaultUrl = getNavItems().defaultUrl;
      console.log("default url:", defaultUrl);
      // this.push(defaultUrl);
      window.location.replace(defaultUrl);
    } catch (ex) {

    }
  };

  render() {
    const { classes, onClick } = this.props;
    const { groups, showPassword, data } = this.state;
    return (
      <>
        <Card variant="outlined" >
          <div style={{width:"100px",margin:"auto"}} >
            <img width={100} src="/logo.jpeg" style={{width:"100px",height:"100px", border:"1px solid gray", borderRadius:"50%"}}/>
          </div>
          <CardContent >
            <form onSubmit={this.handleSubmit}>
              <Grid container>
              <Grid  item sm="12" >
                {this.renderMatInput(
                  {},
                  "username",
                  "Username",
                  "text",
                  "outlined",
                  "medium"
                )}
                {this.renderMatPassword(
                      {},
                      "password",
                      "Password",
                      "password",
                      "outlined",
                      "medium")}


                {/* {this.renderMatCheckbox({}, "rememberme", "Remember me")} */}

                {this.renderMatButton(
                  "Log in",
                  "submit",
                  "info",
                  true,
                  "lock",
                  "large"
                )}
              </Grid>
              <Grid  item sm="12" spacing={5}>
                <br/>
                <Grid container>

                <Grid item xs="6">
                  <Button
                    variant="text"
                    color="primary"
                    >
                    <Link to="/forgot-password">
                      {"Forgot Password ?"}
                    </Link>
                  </Button>
                </Grid>
                <Grid item xs="6" textAlign={"end"}>
                  <Button color="primary" variant="text" onClick={() => onClick(false)}>
                    {"New Enquiry"}
                  </Button>
                    </Grid>
                </Grid>
                <br />
              </Grid>
              </Grid>
            </form>
          </CardContent>
        </Card>
      </>
    );
  }
}

export default SignInForm;
